import { LogoNucleo } from "src/components/HeaderPages/LogoNucleo";

export default function LayoutLogo() {
    return (
      <LogoNucleo />
    );
  }
  